// overlay image directive
//
//   <overlay-image overlay="{...}" on-change="..." />
//
// works closely with the draggable and resizable directives
//

let module = angular.module('app.directives');

module.directive('overlayPreview', function () {
  'ngInject';
  return {
    scope: {
      overlay: '=',
    },
    template: `
      <div class="fixed-16-9 transparent-grid-bg">
        <div class="upload-image" ng-style="{
          'background-image': 'url(&quot;'+overlay.url+'&quot;)',
          'background-repeat': 'no-repeat',
          'background-position': '0% 0%',
          'background-size': 'contain',
        }">
        </div>
      </div>
    `,
  };
});

module.directive('overlayImage', function () {
  'ngInject';
  return {
    scope: {
      overlay: '=',
      onChange: '=',
    },
    template: `
      <div class="overlay-image"
           ng-style="style"
           draggable=""
           resizable=""
           aspect-ratio="overlay.height / overlay.width"
           on-drag="onDrag"
           on-resize="onResize"
           ></div>
    `,
    controller: function ($scope) {
      'ngInject';
      const { overlay } = $scope;
      $scope.style = {
        position: 'absolute',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url("${overlay.url}")`,
        top: 100 * overlay.offsetY + '%',
        left: 100 * overlay.offsetX + '%',
        width: 100 * overlay.scaleWidth + '%',
        height: 100 * overlay.scaleHeight + '%',
      };
      $scope.onDrag = function (xPct, yPct) {
        $scope.onChange(overlay, {
          offsetX: roundFloatTo5Decimals(xPct / 100),
          offsetY: roundFloatTo5Decimals(yPct / 100),
        });
      };
      $scope.onResize = function (wPct, hPct) {
        $scope.onChange(overlay, {
          scaleWidth: roundFloatTo5Decimals(wPct / 100),
          scaleHeight: roundFloatTo5Decimals(hPct / 100),
        });
      };
    },
  };
});

export function uploadImageToOverlay(upload, width, height) {
  var scaleW = width / 1920.0; //simulated canvas assumes 1920x1080
  var scaleH = height / 1080.0; //simulated canvas assumes 1920x1080
  if (scaleW > 1) {
    scaleW = 1;
    scaleH = (height / width) * (1920 / 1080);
  }
  if (scaleH > 1) {
    scaleH = 1;
    scaleW = (width / height) * (1080 / 1920);
  }
  return {
    url: upload.view_url,
    width: width,
    height: height,
    scaleWidth: roundFloatTo5Decimals(scaleW),
    scaleHeight: roundFloatTo5Decimals(scaleH),
    offsetX: 0,
    offsetY: 0,
  };
}

function roundFloatTo5Decimals(val) {
  // api/origin doesn't deal with long floating point well
  return Math.round(val * 100000) / 100000;
}



// WEBPACK FOOTER //
// ./app/directives/overlay-image.js